import React, { useEffect } from "react";

import { routes } from "consts";
import { useNavigate } from "react-router-dom";
import { AdminResourceDeleteModal, PageMain, HeaderWithBreadcrumbs } from "components/molecules";
import { DocumentTypeApi, documentTypesApi } from "api/documentTypesApi";
import { PaziaButton } from "components/atoms";
import {
  TanTable,
  TanTableColumn,
  useFilters,
  usePagination,
  useSorting,
} from "components/molecules";
import { useDocumentTypes } from "api/hooks";
import { useDeleteResourceActions } from "utils/store";

export const DocumentTypesPage = (): JSX.Element | null => {
  const { setDeleteResource } = useDeleteResourceActions();
  const navigate = useNavigate();
  const { searchPhrase, filter } = useFilters();
  const { limit, skip, onPaginationChange, pagination } = usePagination();
  const { sorting, onSortingChange, fieldWithOrder } = useSorting();
  const { isLoading, isFetching, documentTypes, total, invalidate } = useDocumentTypes(
    skip,
    limit,
    searchPhrase,
    filter,
    fieldWithOrder,
  );

  useEffect(() => {
    invalidate();
  }, [sorting, pagination, searchPhrase, filter]);

  const columns = React.useMemo<TanTableColumn<DocumentTypeApi>[]>(
    () => [
      {
        id: "id",
        header: "ID",
        accessorKey: "id",
        enableColumnFilter: false,
        size: 10,
      },
      {
        id: "name",
        header: "Nazwa",
        accessorKey: "name",
        enableColumnFilter: false,
      },
      {
        id: "validity",
        header: "Okres ważności",
        accessorKey: "validity",
        enableColumnFilter: false,
        cell: (cell) => {
          const rowValue = cell.getValue<number>();
          if (rowValue == 0) return "Bezterminowo";
          if (rowValue == 365) return "Rok";
          if (rowValue == 730) return "Dwa lata";
          if (rowValue == 1095) return "Trzy lata";
          return `${rowValue} dni`;
        },
      },
    ],
    [],
  );
  return (
    <PageMain>
      <HeaderWithBreadcrumbs
        headerText="Typy dokumentów"
        headerButton={
          <PaziaButton type="primary" title="Dodaj +" onClick={() => navigate(routes.DOCUMENT_TYPES_ADD)} />
        }
        breadcrumbs={[{ title: "Szablony dokumentów", path: routes.DOCUMENTS }, { title: "Typy dokumentów" }]}
      />
      <TanTable
        data={documentTypes}
        columns={columns}
        loading={isLoading}
        fetching={isFetching}
        total={total}
        onPaginationChange={onPaginationChange}
        onSortingChange={onSortingChange}
        pagination={pagination}
        sorting={sorting}
        onDelete={(x) => setDeleteResource(x.id)}
        onRowClick={(x) => navigate(routes.DOCUMENT_TYPES_EDIT(x.id))}
      />
      <AdminResourceDeleteModal
        title="Usuń typ dokumentu"
        description="Jesteś pewien że chcesz usunąć typ dokumentu?"
        onSuccessDelete={() => invalidate()}
        deleteAction={documentTypesApi.delete}
      />
    </PageMain>
  );
};
